import React from 'react'
import bg from '../../assets/images/lines.png'
import categorydark from '../../assets/icons/categoriesBlack.svg'
import categorylight from '../../assets/icons/categoriesWhite.svg'
import cardsdark from '../../assets/icons/cardsBlack.svg'
import cardslight from '../../assets/icons/cardsWhite.svg'
import currencyWhite from '../../assets/icons/currencyWhite.svg'
import currencyBlack from '../../assets/icons/currencyBlack.svg'
import reportsdark from '../../assets/icons/reportsBlack.svg'
import reportslight from '../../assets/icons/reportsWhite.svg'
import dynamicblack from '../../assets/icons/content-marketingblack.svg'
import dynamicwhite from '../../assets/icons/content-marketingwhite.svg'
import paymentDark from '../../assets/icons/paymentBlack.svg'
import paymentLight from '../../assets/icons/paymentWhite.svg'
import notificationlight from '../../assets/icons/notificationWhite.svg'
import notificationdark from '../../assets/icons/notificationsBlack.svg'
import settingdark from '../../assets/icons/settingsBlack.svg'
import accountlight from '../../assets/icons/accountWhite.svg'
import accountdark from '../../assets/icons/acocuntBlack.svg'
import settingslight from '../../assets/icons/settingsWhite.svg'
import cashblack from '../../assets/icons/cash.svg'
import cashwhit from '../../assets/icons/cashwhite.svg'
import complanetblack from '../../assets/icons/complane.svg'
import complanetwhite from '../../assets/icons/complanewhite.svg'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/AuthContext'

const Sidepare = () => {
  const { pathname } = useLocation()
  const { user } = useAuth()
  return (
    <div className="bg-gradient-to-b from-darkBlue to-lightBlue fixed top-0 left-0 w-1/6  h-screen">
      <div
        style={{
          backgroundImage: `url(${bg})`,
          backgroundPosition: ` -70px 100%`,
        }}
        className="flex flex-col gap-3 justify-start overflow-y-scroll py-8 pl-2 bg-contain bg-no-repeat w-full h-full"
      >
        <div className=" text-white pl-3">
          {user && `welcom ${user.first_name} ${user.last_name}`}
        </div>

        <Link
          to="/"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img src={pathname === '/' ? categorydark : categorylight} alt="" />
          <span> Card Categories</span>
        </Link>

        <Link
          to="/cards"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/cards'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img src={pathname === '/cards' ? cardsdark : cardslight} alt="" />
          <span> Cards</span>
        </Link>

        <Link
          to="/orders"
          className={`flex gap-2 rounded-l-full p-3 ${
            pathname === '/orders'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img src={pathname === '/orders' ? cashblack : cashwhit} alt="" />
          <span>Packge Orders</span>
        </Link>
        <Link
          to="/balance-orders"
          className={`flex gap-2 rounded-l-full p-3 ${
            pathname === '/balance-orders'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/balance-orders' ? cashblack : cashwhit}
            alt=""
          />
          <span>Balance Orders</span>
        </Link>

        <Link
          to="/account-management"
          className={`flex gap-2 rounded-l-full p-3 ${
            pathname === '/account-management'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={
              pathname === '/account-management' ? accountdark : accountlight
            }
            alt=""
          />
          <span>Account Management</span>
        </Link>
        <Link
          to="/dynamic-content"
          className={`flex gap-2 rounded-l-full p-3 ${
            pathname === '/dynamic-content'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/dynamic-content' ? dynamicblack : dynamicwhite}
            alt=""
            className=" w-7 h-7"
          />
          <span>Dynamic Content</span>
        </Link>
        <Link
          to="/currency"
          className={`flex gap-2 rounded-l-full p-3 ${
            pathname === '/currency'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/currency' ? currencyBlack : currencyWhite}
            alt=""
            className=" w-7 h-7"
          />
          <span>Currency</span>
        </Link>

        <Link
          to="/payment-methods"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/payment-methods'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/payment-methods' ? paymentDark : paymentLight}
            alt=""
          />
          <span> Payment Methods</span>
        </Link>

        <Link
          to="/reports"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/reports'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/reports' ? reportsdark : reportslight}
            alt=""
          />
          <span>Reports</span>
        </Link>

        <Link
          to="/notifications"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/notifications'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={
              pathname === '/notifications'
                ? notificationdark
                : notificationlight
            }
            alt=""
          />
          <span>Notifications</span>
        </Link>

        <Link
          to="/complaints"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/complaints'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/complaints' ? complanetblack : complanetwhite}
            alt=""
          />
          <span>Complaints</span>
        </Link>
        <Link
          to="/contact-us-forms"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/contact-us-forms'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={
              pathname === '/contact-us-forms' ? complanetblack : complanetwhite
            }
            alt=""
          />
          <span>Contact Forms</span>
        </Link>

        <Link
          to="/settings"
          className={` flex gap-2 rounded-l-full p-3 ${
            pathname === '/settings'
              ? ' bg-white text-darkBlue'
              : 'bg-transparent text-white'
          }`}
        >
          <img
            src={pathname === '/settings' ? settingdark : settingslight}
            alt=""
          />
          <span>Settings</span>
        </Link>
      </div>
    </div>
  )
}

export default Sidepare
